export const billingTypes = {
  ONE_TIME: 'ONE_TIME',
  QUARTERLY: 'QUARTERLY',
} as const;

export type BillingTypeValues = (typeof billingTypes)[keyof typeof billingTypes];
export const MIN_LICENSE_COUNT = 5;
export const MAX_LICENSE_COUNT = 125;
